exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-wrapper[data-v-22db314e]{margin-bottom:20px}.yuedong-content>div[data-v-22db314e]{margin:2px 0}.link[data-v-22db314e]{color:#409eff;text-decoration:underline;cursor:pointer}.credit-score-campus-content .split[data-v-22db314e]{margin:0 8px;color:#c0c4cc}.yuedong-dialog-list[data-v-22db314e]{max-height:360px;overflow:auto}.yuedong-dialog-item[data-v-22db314e]{padding:6px 4px;border-bottom:1px solid #f0f0f0}.yuedong-dialog-empty[data-v-22db314e]{padding:20px;text-align:center;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-22db314e&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/SystemConfig.vue
// module id = 472
// module chunks = 0